const grid = 'grid';
const float = 'float';

export default {
  grid,
  float,
};
